import { ApiEndpointBuilder } from "@/services/api/types.ts";
import { UserRole } from "@/types/contracts";

const addContractEnterpriseUserRoleEndpoint = (builder: ApiEndpointBuilder) => {
  return builder.mutation<string, Request>({
    query: request => ({
      url: `/contracts/enterprisecontracts/userrole`,
      method: "POST",
      body: request,
    }),
    invalidatesTags: (_r, _e, arg) => [{ type: "contract", id: arg.enterpriseContractId }],
  });
};

export default addContractEnterpriseUserRoleEndpoint;

export type Request = UserRole;
